import { render } from "./LeadEditItem.vue?vue&type=template&id=9f0b86f4"
import script from "./LeadEditItem.vue?vue&type=script&lang=js"
export * from "./LeadEditItem.vue?vue&type=script&lang=js"

import "./LeadEditItem.vue?vue&type=style&index=0&id=9f0b86f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__